import { apiHosts } from "@/api/constants/apiHosts";
import { ToastOptionsSuccess, type ToastOptionsError } from "@modernary/mui/components/toasts";
import { apiService, type PagingApiAndNotifierConfig } from "@modernary/mui/utils/api";
import { serializeQueryParams } from "@modernary/mui/utils/helpers";
import type { DustCard, DustCardQuery } from "./dustCard";

const URL = "dust-cards";
const ENTITY_NAME = "Dust Card";

const api = apiService<DustCard>(apiHosts.AQMS, {
  baseURL: import.meta.env.VITE_AQMS_API_BASE_URL,
});

const getDustCards = (params: DustCardQuery, config: PagingApiAndNotifierConfig = {}) => {
  const successToastCb = (options: ToastOptionsSuccess) => {
    options.hide = true;
    config.successToastCb?.(options);
  };
  const errorToastCb = (options: ToastOptionsError) => {
    options.fetched = ENTITY_NAME;
    config.errorToastCb?.(options);
  };

  return api.getPaged(config.pagingUrl ?? URL, {
    params,
    paramsSerializer: serializeQueryParams,
    abort: config.abortMethod,
    successToastCb,
    errorToastCb,
  });
};

export { getDustCards };
